<template>
  <div class="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-700 p-4 rounded-lg mb-4">
    <div class="grid grid-cols-3 gap-4 text-center">
      <div class="bg-white dark:bg-gray-800 p-3 rounded-lg shadow-sm">
        <div class="text-2xl font-bold text-blue-600">{{ orderCount }}</div>
        <div class="text-sm text-gray-600 dark:text-gray-300">Toplam Sipariş</div>
      </div>
      <div class="bg-white dark:bg-gray-800 p-3 rounded-lg shadow-sm">
        <div class="text-2xl font-bold text-green-600">{{ totalAmount.toFixed(1) }}</div>
        <div class="text-sm text-gray-600 dark:text-gray-300">Toplam Ton</div>
      </div>
      <div class="bg-white dark:bg-gray-800 p-3 rounded-lg shadow-sm">
        <div class="text-2xl font-bold text-purple-600">{{ totalVehicles }}</div>
        <div class="text-sm text-gray-600 dark:text-gray-300">Önerilen Araç</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepTwoDashboard",
  props: {
    orderCount: {
      type: Number,
      default: 0
    },
    totalAmount: {
      type: Number,
      default: 0
    },
    totalVehicles: {
      type: Number,
      default: 0
    }
  }
};
</script>